var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "Budget-Content" }, [
    _c("div", { staticClass: "Left" }, [
      _vm.budget.totalPrice > 0
        ? _c("span", [
            _vm._v(
              _vm._s(_vm.budget.totalPrice) + " " + _vm._s(_vm.budget.currency)
            ),
          ])
        : _c("span", [_vm._v("免费")]),
      _c("img", { attrs: { src: _vm.budget.imageUrl, alt: "" } }),
    ]),
    _c("div", { staticClass: "Right" }, [
      _c(
        "div",
        { staticClass: "R-One R" },
        [
          _c("span", [_vm._v(_vm._s(_vm.budget.resourceNameCn))]),
          _vm.budget.star > 0
            ? _c("van-rate", {
                attrs: { count: _vm.budget.star },
                model: {
                  value: _vm.budget.star,
                  callback: function ($$v) {
                    _vm.$set(_vm.budget, "star", $$v)
                  },
                  expression: "budget.star",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c("div", { staticClass: "R-Two R" }, [
        _c("span", [_vm._v(_vm._s(_vm.budget.timeStr))]),
      ]),
      _c("div", { staticClass: "R-Three R" }, [
        _vm.budget.addressCn
          ? _c("i", { staticClass: "el-icon-location-outline van-icon" })
          : _vm._e(),
        _c("span", { staticClass: "ellipsis" }, [
          _vm._v(_vm._s(_vm.budget.addressCn)),
        ]),
      ]),
      _c("div", { staticClass: "R-Four R" }, [
        _c("span", { staticClass: "ellipsis" }, [
          _vm._v(_vm._s(_vm.budget.introduction)),
        ]),
      ]),
      _c(
        "span",
        { staticClass: "R-Five R" },
        _vm._l(_vm.budget.stockDetail, function (info, infoIndex) {
          return _c("span", { key: infoIndex }, [
            _c("span", [_vm._v(_vm._s(info.budgetType) + " ")]),
            _c("span", [_vm._v(_vm._s(info.timeDesc) + " ")]),
            _c(
              "span",
              { staticStyle: { color: "#000000", "font-weight": "700" } },
              [_vm._v(_vm._s(info.productNameCn) + " ")]
            ),
            _c("span", [_vm._v(_vm._s(info.stockDesc))]),
            _c(
              "span",
              { staticStyle: { color: "#000000", "font-weight": "700" } },
              [
                _vm._v(
                  _vm._s(info.ratio) +
                    _vm._s(info.currency) +
                    _vm._s(info.priceCompany) +
                    "/" +
                    _vm._s(info.useTime)
                ),
              ]
            ),
            _c(
              "span",
              {
                staticStyle: {
                  color: "rgb(142, 43, 11)",
                  "font-weight": "700",
                },
              },
              [_vm._v(" " + _vm._s(info.stockNumber) + " ")]
            ),
            _c(
              "span",
              { staticStyle: { color: "#000000", "font-weight": "700" } },
              [_vm._v(_vm._s(info.priceCompany))]
            ),
            infoIndex + 1 < _vm.budget.stockDetail.length
              ? _c(
                  "span",
                  {
                    staticStyle: {
                      color: "rgb(2, 160, 198)",
                      "font-weight": "bold",
                    },
                  },
                  [_vm._v(" | ")]
                )
              : _vm._e(),
          ])
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }